import {
  FlexRow,
  HashLength,
  NamedKeyPrefix,
} from '@make-software/cspr-design';
import { Tooltip, BodyText } from '@block-explorer/ui';
import CopyButton from '../copy-button/copy-button';
import React from 'react';
import NamedKeyValue from '../named-key-value/named-key-value';
import { useTranslation } from 'react-i18next';

interface TableDataNamedKeyProps {
  purse: string;
  fontSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  hashLength?: HashLength;
}
// TODO: MOVE TO LIB
export const TableDataNamedKey = ({
  purse,
  fontSize = 'xs',
  hashLength = HashLength.TINY,
}: TableDataNamedKeyProps) => {
  const { t } = useTranslation();
  const isURef = purse?.includes(NamedKeyPrefix.UREF);
  return (
    <FlexRow itemsSpacing={4}>
      <Tooltip tooltipContent={purse} caption={isURef ? t('URef Hash') : null}>
        <BodyText size={3} monotype noWrap scale={fontSize}>
          <NamedKeyValue namedKey={purse} hashLength={hashLength} />
        </BodyText>
      </Tooltip>
      <CopyButton value={purse} />
    </FlexRow>
  );
};
